var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 13.2L11.6 13.5996L11.6 16.4C11.6 16.96 11.6 17.2401 11.491 17.454C11.3951 17.6421 11.2421 17.7951 11.054 17.891C10.8401 18 10.56 18 9.99998 18H3.6C3.03995 18 2.75992 18 2.54601 17.891C2.35785 17.7951 2.20487 17.6422 2.10899 17.454C2 17.2401 2 16.9601 2 16.4L2 3.6C2 3.03995 2 2.75992 2.109 2.54601C2.20487 2.35785 2.35785 2.20487 2.54601 2.10899C2.75992 2 3.03995 2 3.6 2L10 2C10.5601 2 10.8401 2 11.054 2.10899C11.2422 2.20487 11.3951 2.35785 11.491 2.54601C11.6 2.75992 11.6 3.03995 11.6 3.6V6.39961V6.8M7.6 9.99961L18 9.99961M18 9.99961L14.8 6.79961M18 9.99961L14.8 13.1996",
    stroke: "#99A4B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignoutIcon);
export default __webpack_public_path__ + "static/media/signout-icon.2172c01b1255a9c6bcaada195c2f9271.svg";
export { ForwardRef as ReactComponent };